const setMobileMenuState = (details, isOpen) => {
  details.toggleAttribute('open', isOpen);
  document.body.classList.toggle('ryng-menu-open', isOpen);
};

document.addEventListener('click', (event) => {
  const closeDetails = event.target.closest('[data-ryng-close-details]');
  if (closeDetails) setMobileMenuState(closeDetails.closest('details'), false);

  const mobileLink = event.target.closest('[data-ryng-mobile-link]');
  if (mobileLink) setMobileMenuState(mobileLink.closest('details'), false);

  const popupClose = event.target.closest('[data-ryng-popup-close]');
  if (popupClose) {
    const popup = popupClose.closest('[data-ryng-popup]');
    if (popup) popup.hidden = true;
    const days = Number(popup?.dataset.days || 7);
    try { localStorage.setItem('ryng-popup-dismissed-until', String(Date.now() + days * 86400000)); } catch (_) {}
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ryng-mobile-nav').forEach((details) => {
    const summary = details.querySelector(':scope > summary');
    summary?.addEventListener('click', () => {
      window.requestAnimationFrame(() => {
        document.body.classList.toggle('ryng-menu-open', details.open);
      });
    });
    details.addEventListener('toggle', () => {
      document.body.classList.toggle('ryng-menu-open', details.open);
    });
  });

  document.querySelectorAll('[data-ryng-announcement]').forEach((announcement) => {
    const items = [...announcement.querySelectorAll('.ryng-announcement__item')];
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let activeIndex = 0;
    window.setInterval(() => {
      items[activeIndex].classList.remove('is-active');
      activeIndex = (activeIndex + 1) % items.length;
      items[activeIndex].classList.add('is-active');
    }, 3500);
  });

  document.querySelectorAll('[data-ryng-popup]').forEach((popup) => {
    let dismissed = false;
    try { dismissed = Number(localStorage.getItem('ryng-popup-dismissed-until') || 0) > Date.now(); } catch (_) {}
    if (dismissed) return;
    const delay = Number(popup.dataset.delay || 8) * 1000;
    window.setTimeout(() => { popup.hidden = false; }, delay);
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const openMenu = document.querySelector('.ryng-mobile-nav[open]');
  if (openMenu) setMobileMenuState(openMenu, false);
});
